"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiFormLabel = void 0;
var colors_1 = require("../colors");
exports.MuiFormLabel = {
    styleOverrides: {
        root: {
            color: '#000',
            fontSize: 14,
            fontWeight: 800,
            lineHeight: '130%',
            '&.Mui-disabled': {
                color: colors_1.tannerGray['400'],
            },
        },
    },
};
//# sourceMappingURL=MuiFormLabel.js.map